import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { commentsCapture, Task } from '@org/interfaces';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {
  private apiUrl = `${environment.apiUrl}/api/tasks`;
  private commentCache: { [taskId: string]: Comment[] } = {};

  constructor(private http: HttpClient) {}

  // Method to fetch comments from backend (or cache)
  // getComments(taskId: string): Observable<any[]> {
  //   // Check if comments are cached
  //   if (this.commentCache[taskId]) {
  //     // Return cached comments as an Observable
  //     return of(this.commentCache[taskId]);
  //   } else {
  //     // Fetch comments from backend and cache them
  //     return this.http.get<any[]>(`${this.apiUrl}/${taskId}/comments`).pipe(
  //       tap((comments ) => {
  //         // Cache the fetched comments
  //         this.commentCache[taskId] = comments;
  //       })
  //     );
  //   }
  // }

  getComments(taskId: string): Observable<any[]> {
   
    // Fetch comments from the cache if they exist
    const cachedComments = this.commentCache[taskId] || [];
  
    return this.http.get<any[]>(`${this.apiUrl}/${taskId}/comments`).pipe(
      map((incomingCommentsObj: any) => {
        const incomingComments = incomingCommentsObj?.comments || [];
        // Compare incoming comments with cached comments
        const newComments = incomingComments.filter((incomingComment: any) => {
          // Check if the comment already exists in the cache
          return !cachedComments.some(
            (cachedComment: any) => cachedComment?._id === incomingComment._id
          );
        });
  
        // Append new comments to the cached comments array
        const updatedComments = [...cachedComments, ...newComments];
  
        // Update the cache with the new comments
        this.commentCache[taskId] = updatedComments;
  
        // Return the updated comments array
        return updatedComments;
      })
    );
  }

 
  
  

  // Clear cache for a specific task (if needed)
  clearCacheForTask(taskId: string): void {
    delete this.commentCache[taskId];
  }

  // Clear all cache (optional)
  clearAllCache(): void {
    this.commentCache = {};
  }
}
